/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { css } from "styled-components";

export const ellipsis = (maxNumberOfLines: number, lineHeight = 22) => {
    return css`
        overflow-wrap: break-word;
        word-wrap: break-word;
        overflow: hidden;
        display: -webkit-box;
        display: -moz-box;
        display: box;
        -moz-box-orient: vertical; /* Mozilla */
        -webkit-box-orient: vertical; /* WebKit */
        box-orient: vertical;
        -moz-line-clamp: ${maxNumberOfLines};
        -webkit-line-clamp: ${maxNumberOfLines};
        line-clamp: ${maxNumberOfLines};
        line-height: ${lineHeight}px;
        max-height: ${maxNumberOfLines * lineHeight}px;
    `;
};

export default ellipsis;
